function removeCurlyBraces (text: string) {
  return text?.replace(/ *\{[^\]]*}/, '')
};

export default removeCurlyBraces
